import { useState } from 'react'

export const useModal = () => {
  const [isModalActive, setIsModalActive] = useState<boolean>(false)

  const handleModalOpen = () => {
    setIsModalActive(true)
  }

  const handleModalClose = () => {
    setIsModalActive(false)
  }

  const handleModalSwitch = () => {
    setIsModalActive((prev) => !prev)
  }

  return { isModalActive, handleModalOpen, handleModalClose, handleModalSwitch }
}
